/**
 * Kurzer Lese-Hinweis für reine Betrachter (nicht angemeldet bzw. Datennutzer)
 * statt des ausführlichen rollen-/status-spezifischen Workflow-Sperrtexts
 * (`explainEditBlock`). Differenziert nach Anmeldestatus (User-Wunsch 2026-05-25):
 *
 *  - **nicht angemeldet** → Anmelde-Aufforderung
 *  - **angemeldeter Datennutzer** → nur Lese-Hinweis
 *  - **höhere Rolle** (Bearbeiter/Kontrolleur/Manager — kein Datennutzer) →
 *    `null`: diese sehen weiter den detaillierten `explainEditBlock`-Banner.
 *
 * Rein (kein Angular-DI) für einfache Testbarkeit.
 */
export function readonlyViewerHint(isAuthenticated: boolean, isDatennutzer: boolean): string | null {
	if (!isAuthenticated) return 'Nur-Lese-Ansicht — zum Bearbeiten bitte anmelden.';
	if (isDatennutzer) return 'Nur-Lese-Ansicht.';
	return null;
}
